/**
 * Tiny English count-noun helper. Pure + dependency-free so it's unit-testable.
 *
 * `pluralize(1, 'troop')` → `'1 troop'`
 * `pluralize(3, 'troop')` → `'3 troops'`
 * `pluralize(1, 'territory', 'territories')` → `'1 territory'`
 *
 * Only `count === 1` (and `-1`) takes the singular — every other value,
 * including 0, takes the plural ("0 troops"), which is the conventional
 * English form.
 */
export function pluralize(count: number, singular: string, plural?: string): string {
  const word = Math.abs(count) === 1 ? singular : (plural ?? `${singular}s`)
  return `${count} ${word}`
}
